import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { TmrODataConfiguration } from '@exchange/services/core/odata/config'
import { ODataService } from 'common-services'

export interface IRemitLineProgress extends IModelBase {
  RemittanceId: number
  ServicePaymentId: number
  Validation: string
  Status: string
  Field: string
  FieldValue: string
  TimeStamp: Date
  ShortMessage: string
  Message: string
}

@Injectable()
export class RemitLineProgressODataService extends ODataService<IRemitLineProgress> {
  constructor(
    protected http: HttpClient,
    protected config: TmrODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProcessingView'
  }
}
